/* global axios */
import ApiClient from '../ApiClient';

class LlmLogsAPI extends ApiClient {
  constructor() {
    super('captain/llm_logs', { accountScoped: true });
  }

  index(params = {}) {
    const { page = 1, ...filters } = params;
    const query = { page };
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== '' && value != null) {
        query[key] = value;
      }
    });
    return axios.get(this.url, { params: query });
  }
}

export default new LlmLogsAPI();
